import { Grid } from "@material-ui/core";
import ParticipationRequestForm from "../../../../forms/autorizacaoEspecial/ParticipationRequestForm";
import FormBase from "../../../../forms/FormBase";
import { SolicitacaoAcompanhamentoClinicoOptions } from "../../../../data/SolicitacaoAcompanhamentoClinico";
import { SolicitacaoParticipacaoCirurgiaOptions } from "../../../../data/SolicitacaoParticipacaoCirurgia";
import Controls from "../../../../components/controls/Controls";


interface ParticipationRequestComponentProps {
  ParticipationRequestForm: ParticipationRequestForm;
  onInputChange: (name: string, form: FormBase, value: any) => void;
}

export default function ParticipationRequestComponent(
  props: ParticipationRequestComponentProps
) {
  return (
    <div>
      <Grid container spacing={5}>
        <Grid item xs={12} sm={12}>
          <Controls.RadioGroup
            name="RequestParticipate"
            label="Solicitação de participação em cirurgia (inclui o acompanhamento do paciente internado)"
            value={props.ParticipationRequestForm.RequestParticipate.Value}
            onChange={(e) => {
              props.onInputChange(
                "RequestParticipate",
                props.ParticipationRequestForm,
                e.target.value
              );
            }}
            items={SolicitacaoParticipacaoCirurgiaOptions}
            error={props.ParticipationRequestForm.RequestParticipate.Error}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controls.Input
            name="Name"
            label="Nome do médico responsável pelo paciente / procedimento *"
            maxLength={60}
            placeholder="Digite o nome completo"
            value={props.ParticipationRequestForm.NameResponsible.Value}
            onChange={(e) => {
              props.onInputChange(
                "NameResponsible",
                props.ParticipationRequestForm,
                e.target.value
              );
            }}
            onBlur={(e) => {
              props.onInputChange(
                "NameResponsible",
                props.ParticipationRequestForm,
                e.target.value
              );
            }}
            error={props.ParticipationRequestForm.NameResponsible.Error}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controls.RadioGroup
            name="Region"
            label="Solicitação de Acompanhamento Clínico de Paciente Internado:"
            value={props.ParticipationRequestForm.RequestFollow.Value}
            onChange={(e) => {
              props.onInputChange(
                "RequestFollow",
                props.ParticipationRequestForm,
                e.target.value
              );
            }}
            items={SolicitacaoAcompanhamentoClinicoOptions}
            error={props.ParticipationRequestForm.RequestFollow.Error}
          />
        </Grid>
      </Grid>
    </div>
  );
}
